import Vue from 'vue';
import utils from './utils';

Vue.filter('numberFormat', function (value) {
    return utils.numberFormat(value);
});
